import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SystemStatusSocketService } from '@service/system-status-socket.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-disconnected-snack-bar',
    templateUrl: './disconnected-snack-bar.component.html',
    styleUrl: './disconnected-snack-bar.component.scss',
    standalone: false,
})
export class DisconnectedSnackBarComponent implements OnInit, OnDestroy {
    showSnackbar: boolean = false;
    private destroySubscriptionSubject$ = new Subject<void>();

    constructor(
        private systemStatusSocket: SystemStatusSocketService,
        private router: Router,
        private cdr: ChangeDetectorRef,
    ) {}
    ngOnInit(): void {
        this.systemStatusSocket
            .updateConnectionSubject()
            .pipe(takeUntil(this.destroySubscriptionSubject$))
            .subscribe(async (isReceivingData) => {
                if (this.showSnackbar == !isReceivingData) return;
                this.showSnackbar = !isReceivingData;
                this.cdr.detectChanges();
            });
    }

    ngOnDestroy(): void {
        this.destroySubscriptionSubject$.next();
        this.destroySubscriptionSubject$.complete();
    }

    goToStatusPage() {
        this.router.navigate(['/ops/system-status']);
    }
}
